import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportRoutingModule } from './report-routing.module';
import { ReportHomeComponent } from './report-home/report-home.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ReportHomeComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    ReportRoutingModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot()
  ]
})
export class ReportModule {

}
